module.exports = __webpack_public_path__ + "static/media/menuEditor_unselected.7c06347d.svg";